<!--
 * @Author: v_aydwang
 * @Date: 2022-12-30 10:45:23
 * @LastEditors: v_aydwang
 * @LastEditTime: 2023-01-11 14:38:56
 * @Description: 大屏-卡片样式
-->
<template>
  <div id="card_modules">
    <div class="card-two" :style="
        ` background: url( ${cardInfo.backStyle} ) no-repeat center / 100% 100%  `
      "
      :class="cardInfo.title == '有效时长'?'time':''"
      >
      <div class="titlt-top">
        <p class="titlt">{{ cardInfo.title }}</p>
        <div
          :class="cardInfo.count > 0 ? 'time-warn' : 'time-normal'"
        >
          <span></span>
          <div v-if="cardInfo.count > 0">
            <Marquee
              :text="
                `周期内触发 ${cardInfo.count} 次${cardInfo.title}预警，需要关注`
              "
            >
            </Marquee>
          </div>
          <div v-else style="cursor: default">{{`周期内未触发${cardInfo.title}预警`}}</div>
        </div>
      </div>
      <div class="titlt-con">
        <div class="con">
          <p class="left-one">{{ cardInfo.con }}</p>
          <p class="left-two">
            <countTo
            :val="cardInfo.value"
            />
            <span v-if="cardInfo.title == '有效时长'"> h</span>
          </p>
          <!-- <p class="left-three">月环比+10%</p> -->
        </div>
        <div class="con—target">
          <p class="left-three">目标值</p>
          <p class="left-four">
            {{ cardInfo.standard
            }}<span v-if="cardInfo.title == '有效时长'"> h</span>
          </p>
        </div>
      </div>
      <div class="titlt-bottom">
        <div class="rank-con">
          <p class="title">供应商产线排名</p>
          <p class="number">
            {{ cardInfo.rank }}<span>/{{ cardInfo.totalRank }}</span>
          </p>
        </div>
        <div>
          <p class="title">产线排名</p>
          <div
            class="rank"
            :style="
              ` background: url( ${rankingImage[cardInfo.image]} ) no-repeat center / 100% 100% `
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Marquee from '@/components/Marquee';
import countTo from '@/components/numGif';
export default {
  components: {
    Marquee,
    countTo,
  },
  props: {
    cardInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      warnVisible: false,
      rankingImage: {
        头部: require('../../assets/personnel-large/rank1.png'),
        中上等: require('../../assets/personnel-large/rank2.png'),
        中等: require('../../assets/personnel-large/rank3.png'),
        中下等: require('../../assets/personnel-large/rank4.png'),
        尾部: require('../../assets/personnel-large/rank5.png'),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/convert-viewport";
@import "@/styles/cardAssembly";

#card_modules {
  .card-two {
    width: vw(454);
    height: vh(264);
    padding: vh(24) vw(20) vh(10) vw(43);
    .titlt-top {
      margin-bottom: vh(14);
      .titlt {
        font-size: vw(20);
        line-height: vh(28);
        margin-right: vw(18);
      }
      .normal,
      .warn,
      .time-warn,
      .time-normal {
        height: vh(40);
        font-size: vw(14);
        line-height: vh(40);
        padding-left: vw(20);
        position: relative;
        display: flex;
        align-items: center;
        span {
          width: vw(18);
          height: vh(18);
          margin-right: vw(4);
          vertical-align: sub;
        }
      }
      .time-warn,
      .time-normal {
        min-width: vw(290);
        // margin-left: vw(5);
      }
    }
    .titlt-con {
      margin-top: vh(5);
      .con {
        width: vw(160);
      }
      .con-little {
        width: vw(100);
      }
      .con,
      .con-little {
        .left-one {
          font-size: vw(14);
          line-height: vh(30);
        }
        .left-two {
          font-size: vw(28);
          line-height: vh(34);
          height: vh(34);
          display: flex;
          span {
            font-size: vw(14);
            line-height: vh(26);
            margin-top: vh(8);
            margin-left: vw(2);
          }
        }
        .left-three {
          font-size: vw(14);
          line-height: vh(18);
          span {
            font-size: vw(14);
            line-height: vh(22);
          }
        }
      }
    }
    .titlt-bottom {
      margin-top: vh(10);
      .rank-con {
        width: vw(160);
      }
      div {
        .title {
          font-size: vw(14);
          line-height: vh(22);
          margin-bottom: vh(10);
        }
        .con {
          font-size: vw(14);
          line-height: vh(22);
          span {
            font-size: vw(14);
            line-height: vh(22);
          }
        }
        .number {
          font-size: vw(32);
          line-height: vh(32);
          span {
            font-size: vw(16);
            line-height: vh(32);
          }
        }
        .rank {
          width: vw(60);
          height: vh(44);
          margin-top: vh(-4);
        }
      }
    }
  }
  .time{
    padding: vh(24) vw(20) vh(10) vw(46);
  }
  .card-two {
    .con—target {
      .left-three {
        margin-right: vw(10);
        font-size: vw(14);
        line-height: vh(24);
      }
      .left-four {
        font-size: vw(20);
        line-height: vw(24);
        span {
          font-size: vw(12);
          line-height: vh(22);
        }
      }
    }
  }
}
.close-x {
  width: vw(32);
  height: vw(32);
  background: url("../../assets/personnel-large/close.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: vh(8);
  right: vw(10);
  cursor: pointer;
}
p {
  margin-bottom: 0;
}
</style>
<style lang="less" scoped>
/deep/.ant-carousel-vertical .slick-dots-right {
  display: none !important;
}
</style>
